import { initializeApp } from "firebase/app";
import { getAnalytics, initializeAnalytics, setUserProperties } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE__MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Disable auto page_view so only manual logEvent calls fire
initializeAnalytics(app, { config: { send_page_view: false } });

/**
 * Get internal emails from environment variable.
 * Uses REACT_APP_INTERNAL_EMAILS, with REACT_APP_DEVELOPER_EMAILS as fallback for compatibility.
 */
const getInternalEmails = () => {
  const envEmails = process.env.REACT_APP_INTERNAL_EMAILS || process.env.REACT_APP_DEVELOPER_EMAILS || "";

  return new Set(
    envEmails
      .split(/[,;\n]/)
      .map((email) => email.trim().toLowerCase())
      .filter(Boolean)
  );
};

const normalizeEmail = (email?: string) => (email || "").trim().toLowerCase();

const firebase = () => {
  // Try to get user data from localStorage
  let userEmail: string | undefined;
  let userCountry: string | undefined;

  try {
    const userDataRaw = localStorage.getItem('userData');
    if (userDataRaw) {
      const userData = JSON.parse(userDataRaw) as { email?: string; country?: string; location?: string };
      userEmail = userData.email;
      userCountry = userData.country || userData.location;
    }
  } catch (e) {
    // Ignore JSON parse errors
    console.error('Error parsing localStorage data for analytics user properties', e);
  }

  const analytics = getAnalytics(app);
  const perf = getPerformance(app);

  const internalEmails = getInternalEmails();
  const normalizedUserEmail = normalizeEmail(userEmail);
  const hasResolvedUser = normalizedUserEmail.length > 0;

  let appUserType: string;
  if (!hasResolvedUser) {
    appUserType = 'unknown';
  } else if (internalEmails.has(normalizedUserEmail)) {
    appUserType = 'internal';
  } else {
    appUserType = 'customer';
  }
  const appUserCountry = userCountry || process.env.REACT_APP_DEFAULT_COUNTRY || 'unknown';

  setUserProperties(analytics, {
    app_user_type: appUserType,
    app_user_country: appUserCountry,
  });

  return {
    analytics,
    perf,
  };
};
export default firebase;
